import SpinningList from './SpinningList';

export default SpinningList;
